module.exports = __webpack_public_path__ + "static/media/Bandeira_Cidade-Jardim.973f546d.png";